const GIFT_FINDER_COLLECTION_ID = '187307360389'; 
const giftFinderCollectionPath ='/collections/gift-finder'; 
//GIFT FINDER OPTIONS
const gf_options = {
    age: {
        // option name: tag name
        "all": "GF_Age_All",
        "0-3 months": "GF_Age_0 – 3",
      	"3-6 months": "GF_Age_3 – 6",
     	"6-12 months": "GF_Age_6 – 12",
      	"12-18 months": "GF_Age_12 – 18",
      	"18-24 months": "GF_Age_18 – 24",
      	"24-36 months": "GF_Age_24 – 36",
        "3 years": "GF_Age_3",
        "4 years": "GF_Age_4",
        "5 years": "GF_Age_5",
        "6 years": "GF_Age_6",
        "7 years": "GF_Age_7",
        "8 years": "GF_Age_8",
        "9 years": "GF_Age_9",
        "10 years": "GF_Age_10",
        "11+ years": "GF_Age_11+",
        optionsOrder: ["all","0-3 months", "3-6 months", "6-12 months", "12-18 months", "18-24 months", "24-36 months","3 years","4 years","5 years","6 years","7 years","8 years","9 years","10 years","11+ years"]
    },
    category: {
        // option name: tag name
        "all" : "GF_Cat_All",
        "active play": "GF_Cat_Active play",
        "art": "GF_Cat_Art",
        "bath toys": "GF_Cat_Bath toys",
        "blocks": "GF_Cat_Blocks",
        "brainteasers": "GF_Cat_Brainteasers",
        "building": "GF_Cat_Building",
        "collecting": "GF_Cat_Collecting",
        "crafts": "GF_Cat_Crafts",
        "dolls": "GF_Cat_Dolls",
        "dress-up": "GF_Cat_Dress-up",
        "electronics": "GF_Cat_Electronics",
        "fashion": "GF_Cat_Fashion",
        "figures & play sets": "GF_Cat_Figures & play sets",
        "games": "GF_Cat_Games",
        "learning": "GF_Cat_Learning",
        "magic": "GF_Cat_Magic",
        "make-believe": "GF_Cat_Make-believe",
        "math & logic": "GF_Cat_Math & logic",
        "music": "GF_Cat_Music",
        "outdoor play": "GF_Cat_Outdoor play",
        "plush toys": "GF_Cat_Plush toys",
        "puppets": "GF_Cat_Puppets",
        "puzzles": "GF_Cat_Puzzles",
        "reading": "GF_Cat_Reading",
        "ride on": "GF_Cat_Ride On",
        "robots": "GF_Cat_Robots",
        "sand & water": "GF_Cat_Sand & water",
        "science": "GF_Cat_Science",
        "sensory toys": "GF_Cat_Sensory toys",
        "sports": "GF_Cat_Sports",
        "sweets & treats": "GF_Cat_Sweets & Treats",
        "toddler play & development": "GF_Cat_Toddler play & development",
        "toy vehicles": "GF_Cat_Toy Vehicles",
      	"trains": "GF_Cat_Trains",
        "trends": "GF_Cat_Trends",
        "wooden toys": "GF_Cat_Wooden toys",
        "writing": "GF_Cat_Writing",
        optionsOrder: ["all", "active play", "art", "bath toys", "blocks", "brainteasers", "building", "collecting", "crafts", "dolls", "dress-up", "electronics", "fashion", "figures & play sets", "games", "learning", "magic", "make-believe", "math & logic", "music", "outdoor play", "plush toys", "puppets", "puzzles", "reading", "ride on", "robots", "sand & water", "science", "sensory toys", "sports", "sweets & treats", "toddler play & development", "toy vehicles", "trains", "trends", "wooden toys", "writing"]
    },
    popular_with: {
        // option name: tag name
        "all kids": "GF_Pop_All Kids",
        "boys": "GF_Pop_Boys",
        "girls" : "GF_Pop_Girls",
        optionsOrder: ["all kids","boys","girls"]
    }
};

// check if you are on the gift-finder collection
function isGiftFinderPage(){
  if(window.location && window.location.href && window.location.href.toLowerCase().indexOf(giftFinderCollectionPath) > -1){
    return true;
  }
  return false;
}

// if you are not in the gift-finder collection load to the mega menu otherwise load on top of the results
///if(isMenuItem) {
    window.addEventListener("load", function () {
        GIFT_FINDER_OBJECT.gf_init();
    });
//}

function fastsimonNavagation(){
      if( window.location && window.location.href){
          if(isGiftFinderPage){ //product finder page
            if(document.querySelector('body') && !document.querySelector('body').classList.contains('fast_simon_gift_finder_page') ){
                document.querySelector('body').classList.add('fast_simon_gift_finder_page');
            }
            if( document.getElementById('fast-simon-serp-app') && 
                document.getElementById('fast-simon-serp-app').shadowRoot && 
                document.getElementById('fast-simon-serp-app').shadowRoot.querySelector('#fs-serp-page') && 
                !document.getElementById('fast-simon-serp-app').shadowRoot.querySelector('#fs-serp-page').classList.contains('fastsimon_gf')){
                      document.getElementById('fast-simon-serp-app').shadowRoot.querySelector('#fs-serp-page').classList.add('fastsimon_gf');
            }
          }
          else if(!isGiftFinderPage){ //other pages
            if(document.querySelector('body') && document.querySelector('body').classList.contains('fast_simon_gift_finder_page') ){
                document.querySelector('body').classList.remove('fast_simon_gift_finder_page');
            }
            if( document.getElementById('fast-simon-serp-app') && 
                document.getElementById('fast-simon-serp-app').shadowRoot && 
                document.getElementById('fast-simon-serp-app').shadowRoot.querySelector('#fs-serp-page') && 
                document.getElementById('fast-simon-serp-app').shadowRoot.querySelector('#fs-serp-page').classList.contains('fastsimon_gf')){
                      document.getElementById('fast-simon-serp-app').shadowRoot.querySelector('#fs-serp-page').classList.remove('fastsimon_gf');
            }
          }
      }

}
      

// This object is in charge of all the gift finder functionality
const GIFT_FINDER_OBJECT = {
    consts: {
        age_tag_name : "GF_Age",
        category_tag_name : "GF_Category",
        popular_with_tag_name: "GF_Pop",
        price_filter_name: "Price_from_to"
    },
    vars: {
        age_narrow: null,
        category_narrow: null,
        popular_with_narrow: null,
        price_narrow: null,
        max_available_price: 500,
    },
    /**
     * gf_init - initialize the gift finder (append the html to the DOM
     */
    gf_init: function () {
        fastsimonNavagation();
      
        if(document.querySelector("[id*=gift_finder_dropdown]")) return;
      
        if( isGiftFinderPage() && document.querySelector("#fast-simon-serp-app") ) { 
            document.querySelector("#fast-simon-serp-app").insertAdjacentHTML('beforebegin', this.get_gf_html(0));
            const selects = document.querySelectorAll('.gf_select');
            if (selects.length) {
                selects.forEach((e,i) => {
                    NiceSelect.bind(e);
                })
            }
        }
        
        this.gf_set_price_slider();
        this.gf_init_events();
    },

    /**
     * create the gift finder html
     *
     * @returns {string} (HTML)
     */
  	get_gf_html: function (index) {
        const setup = getGiftFinderSetup();
        let selected;

        let gf_mega_menu = `<div id="gift_finder_dropdown-${index}" class="gift_finder_dropdown_sec" data-dropdown="product_finder" isMenuItem="${!isGiftFinderPage()}">`;
        if(!isGiftFinderPage()) {
            gf_mega_menu += '<div class="mega_menu_image_content_section">';
        }
        gf_mega_menu += '<h3 class="isp_gf_title-1">We can help you find the perfect gift.</h3>';
        gf_mega_menu += '<h4 class="isp_gf_title-2">Just fill in a few details!</h4>';
        gf_mega_menu += '<div class="gift_finder_wrapper">';
        gf_mega_menu += '<h4 class="isp_gf_title-3">Show me gift ideas</h4>';

        gf_mega_menu += '<div class="gf_select_wrapper">';
        // age select box
        gf_mega_menu += `<span><select class="gf_select gf_select_age" id="gf_select_age-${index}">`;
        gf_mega_menu += '<option value="default" selected="selected">For Age</option>';
        for(let age of gf_options.age.optionsOrder){
            if(setup.age && setup.age === gf_options.age[age]){
                selected = "selected";
                this.vars.age_narrow = gf_options.age[age];
            } else {
                selected = "";
            }
            selected = setup.age && setup.age === gf_options.age[age] ? "selected" : "";
            gf_mega_menu += `<option value="${age}" ${selected}>${age}</option>`;
        }
        gf_mega_menu += '</select></span>';

        //category select box
        gf_mega_menu += `<span><select class="gf_select gf_select_category" id="gf_select_category-${index}">`;
        gf_mega_menu += '<option value="default" selected="selected">In the Category</option>';
        for(let category of gf_options.category.optionsOrder){
            if(setup.category && setup.category === gf_options.category[category]){
                selected = "selected";
                this.vars.category_narrow = gf_options.category[category];
            } else {
                 selected = "";
            }
            gf_mega_menu += `<option value="${category}" ${selected}>${category}</option>`;
        }
        gf_mega_menu += '</select></span>';

        //popular with select box
        gf_mega_menu += `<span><select class="gf_select gf_select_popular_with" id="gf_select_popular_with-${index}">`;
        gf_mega_menu += '<option value="default" selected="selected">Popular With</option>';
        for(let popular of gf_options.popular_with.optionsOrder){
            if(setup.popular_with && setup.popular_with === gf_options.popular_with[popular]){
                selected = "selected";
                this.vars.popular_with_narrow = gf_options.popular_with[popular];
            } else {
                selected = "";
            }
            gf_mega_menu += `<option value="${popular}" ${selected}>${popular}</option>`;
        }
        gf_mega_menu += '</select></span>'; // close select
        gf_mega_menu += '</div>'; // close gf_select_wrapper

        // price slider base wrapper (initialized dynamically with nouislider)
        gf_mega_menu += '<div class="gf_budget_wrapper">';
        gf_mega_menu += '<h4 class="isp_gf_title-3">By Budget</h4>';
        gf_mega_menu += `<div class="gf_price_slider" id="gf_price_slider-${index}"></div>`;
        gf_mega_menu += '</div>';
      	gf_mega_menu += '<div class="gf_button_wrapper">';
        gf_mega_menu += `<button class="show_gift_ideas_btn" id="show_gift_ideas_btn-${index}">Show Gift Ideas <span></span></button>`;
        gf_mega_menu += `<button class="reset_gift_ideas_btn" id="reset_gift_ideas_btn-${index}">Reset</button>`;
		gf_mega_menu += '</div>';
      	gf_mega_menu += '</div>';
      
        // if in menu close dropdown menu, close mega_menu_image_content_section
      	if(!isGiftFinderPage()) {
          	gf_mega_menu += '</div>';
      	}
      
      	gf_mega_menu += '</div>';
        return gf_mega_menu;
    },

    /**
     * initialize all gift finder event listeners
     */
    gf_init_events: function () {

        // Every select change listener
        let select =  document.getElementsByClassName('gf_select');
        for (let i = 0; i < select.length; i++) {
            select[i].addEventListener("change",function () {
                GIFT_FINDER_OBJECT.gf_update_narrow(select[i]);
            });
        }

        // Gift finder search button event
        [...document.querySelectorAll(`.show_gift_ideas_btn`)].forEach(element => {
            element.addEventListener("click",function () {
                  let newNarrow = GIFT_FINDER_OBJECT.gf_get_narrow_term();                  
                  //Narrow
                  document.dispatchEvent(new CustomEvent('send-fast-simon-params', {detail: {narrow: newNarrow }}));  
              
            });
        });

        //  Gift finder Reset button event
        [...document.querySelectorAll(`.reset_gift_ideas_btn`)].forEach(element => {
            element.addEventListener("click",function () {
                GIFT_FINDER_OBJECT.gf_reset_narrow();
            });
        });

    },

    /**
     * price slider initialized using nouislider
     *
     *
      */
    gf_set_price_slider: function(){
        const setup = getGiftFinderSetup();
        const numberOfSliders = document.querySelectorAll('.gf_price_slider').length;
        for (let i = 0; i < numberOfSliders; i++) {
            var slider = document.getElementById(`gf_price_slider-${i}`);
            if (typeof noUiSlider !== "undefined" && slider && !slider.noUiSlider) {
                if (!slider) return;
                if(setup.price) this.vars.price_narrow = setup.price;

                noUiSlider.create(slider, {
                    connect: true,
                    start: setup.price || [0, 120],
                    range: {
                        'min': 0,
                        'max': 120,
                    },
                    step: 10,
                    pips: {
                        filter: filter_gf_pips,
                        mode: 'steps',
                        density: 3,
                    }
                });

                slider.noUiSlider.on("set", function (values) {
                    let leftValue = parseInt(values[0]);
                    let rightValue = parseInt(values[1]);

                    if (rightValue === 110) rightValue = 150;
                    if (rightValue === 120) rightValue = 200;
                    if (leftValue === 110) leftValue = 150;
                    if (leftValue === 120) leftValue = 200;

                    if (leftValue === 0 && rightValue === 200) {
                        GIFT_FINDER_OBJECT.vars.price_narrow = null;
                    } else if (rightValue === 200) {
                        GIFT_FINDER_OBJECT.vars.price_narrow = [leftValue, GIFT_FINDER_OBJECT.vars.max_available_price];
                    } else {
                        GIFT_FINDER_OBJECT.vars.price_narrow = [leftValue, rightValue];
                    }

                    if (GIFT_FINDER_OBJECT.vars.age_narrow || GIFT_FINDER_OBJECT.vars.category_narrow || GIFT_FINDER_OBJECT.vars.category_narrow || GIFT_FINDER_OBJECT.vars.price_narrow) {
                        $('.show_gift_ideas_btn span').html('(Loading...)');
                        GIFT_FINDER_OBJECT.gf_gift_search()
                    } else {
                        $('.show_gift_ideas_btn span').html('');
                    }
                    $(".gf_price_slider").not(slider).each(function () {
                        if(this.noUiSlider && (this.noUiSlider.get()[0] !== values[0] || this.noUiSlider.get()[1] !== values[1])){
                            this.noUiSlider.set(values);
                        }
                    });
                });

            } else {
                window.addEventListener("load", GIFT_FINDER_OBJECT.gf_set_price_slider)
            }

            $('.noUi-value-horizontal[data-value="110"]').text(150);
            $('.noUi-value-horizontal[data-value="120"]').text("200+");

            function filter_gf_pips(value, type) {
                if (value % 10 !== 0) {
                    return -1;
                }
                return 2;
            }
        }
    },

    gf_reset_narrow: function(){
        GIFT_FINDER_OBJECT.vars.age_narrow = null;
        GIFT_FINDER_OBJECT.vars.category_narrow = null;
        GIFT_FINDER_OBJECT.vars.popular_with_narrow = null;
        $(".show_gift_ideas_btn span").html('');

        //TODO handle Price reset
        $(".gf_price_slider").each(function () {
            if(this.noUiSlider) this.noUiSlider.set([0,120]);
        });
        $(".gf_select_age, .gf_select_category, .gf_select_popular_with").each(function () {
            this.selectedIndex = 0;
        });
    },

    gf_update_narrow: function(select){
        const index = select.id.split("-")[1];
        const selectAgeIndex = document.getElementById(`gf_select_age-${index}`).selectedIndex;
        const selectAgeValue = document.getElementById(`gf_select_age-${index}`).options[selectAgeIndex].value;
        const selectCategoryIndex = document.getElementById(`gf_select_category-${index}`).selectedIndex;
        const selectCategoryValue = document.getElementById(`gf_select_category-${index}`).options[selectCategoryIndex].value;
        const selectPopularIndex = document.getElementById(`gf_select_popular_with-${index}`).selectedIndex;
        const selectPopularValue = document.getElementById(`gf_select_popular_with-${index}`).options[selectPopularIndex].value;


        if(selectAgeValue && selectAgeValue !== "default"){
            GIFT_FINDER_OBJECT.vars.age_narrow = selectAgeValue;
            $(".gf_select_age").each(function () {this.selectedIndex = selectAgeIndex;})
        } else {
            GIFT_FINDER_OBJECT.vars.age_narrow = null;
            $(".gf_select_age").each(function () {this.selectedIndex = 0;})
        }

        if(selectCategoryValue && selectCategoryValue !== "default"){
            GIFT_FINDER_OBJECT.vars.category_narrow = selectCategoryValue;
            $(".gf_select_category").each(function () {this.selectedIndex = selectCategoryIndex;})
        } else {
            GIFT_FINDER_OBJECT.vars.category_narrow = null;
            $(".gf_select_category").each(function () {this.selectedIndex = 0;})
        }

        if(selectPopularValue && selectPopularValue !== "default"){
            GIFT_FINDER_OBJECT.vars.popular_with_narrow = selectPopularValue;
            $(".gf_select_popular_with").each(function () {this.selectedIndex = selectPopularIndex;})
        } else {
            GIFT_FINDER_OBJECT.vars.popular_with_narrow = null;
            $(".gf_select_popular_with").each(function () {this.selectedIndex = 0;})
        }

        if(GIFT_FINDER_OBJECT.vars.age_narrow || GIFT_FINDER_OBJECT.vars.category_narrow || GIFT_FINDER_OBJECT.vars.popular_with_narrow ||GIFT_FINDER_OBJECT.vars.price_narrow){
            $('.show_gift_ideas_btn span').html('(Loading...)');
            GIFT_FINDER_OBJECT.gf_gift_search()
        } else {
            $('.show_gift_ideas_btn span').html('');
        }
    },

    gf_get_narrow_array_term: function () {
        const narrow = this.gf_get_narrow_array();
        return '?narrow=' + encodeURIComponent(JSON.stringify(narrow))
    },
  
    gf_get_narrow_term: function () {
        const narrow = this.gf_get_narrow_object();
        return narrow; //'?narrow=' + encodeURIComponent(JSON.stringify(narrow))
    },

    gf_gift_search: function () {
        const categoryId = GIFT_FINDER_COLLECTION_ID; 
        const facetsRequired = 1;
        //const narrowObject = this.gf_get_narrow_object()
        const narrow = JSON.stringify(this.gf_get_narrow_array());
        
        if( (typeof MMClient!== 'undefined') && typeof MMClient.categoriesNavigation !== 'undefined' && typeof narrow !== 'undefined' && narrow.length > 0 ) {
             MMClient.categoriesNavigation(categoryId, facetsRequired, "GIFT_FINDER_OBJECT.gf_handle_results", {narrow});
        }
    },

    gf_get_narrow_array: function(){
        let narrow = [];
        if(this.vars.age_narrow){
            narrow.push([this.consts.age_tag_name,gf_options.age[this.vars.age_narrow]]);
        }
        if(this.vars.category_narrow){
            narrow.push([this.consts.category_tag_name,gf_options.category[this.vars.category_narrow]]);
        }
        if(this.vars.popular_with_narrow){
            narrow.push([this.consts.popular_with_tag_name,gf_options.popular_with[this.vars.popular_with_narrow]]);
        }
        if(this.vars.price_narrow){
            narrow.push([this.consts.price_filter_name,this.vars.price_narrow[0] +"-"+ this.vars.price_narrow[1]]);
        }

        return narrow;
    },
  
    gf_get_narrow_object: function(){
        let narrow = {};
      
        if(this.vars.age_narrow){
            narrow[this.consts.age_tag_name] = new Set([gf_options.age[this.vars.age_narrow]]);
        }
        if(this.vars.category_narrow){
            narrow[this.consts.category_tag_name] = new Set([gf_options.category[this.vars.category_narrow]]);
        }
        if(this.vars.popular_with_narrow){
            narrow[this.consts.popular_with_tag_name] = new Set([gf_options.popular_with[this.vars.popular_with_narrow]]);
        }
        if(this.vars.price_narrow){
          let priceRange = this.vars.price_narrow[0] +"-"+ this.vars.price_narrow[1];
          narrow[this.consts.price_filter_name] = new Set([priceRange]);
        }

        return narrow;
    },

    priceIdToNormalPrice: function(price_id){
        price_id = price_id.replaceAll("CAD:","").split("-");
        return [parseFloat(price_id[0]), parseFloat(price_id[1])];
    },

    gf_handle_results: function (data) {
        if(!data.total_results) data.total_results = 0;

        if(data.total_results === 0){
            $(".show_gift_ideas_btn").attr("disabled","");
        } else {
            $(".show_gift_ideas_btn").removeAttr("disabled");
        }

        $('.show_gift_ideas_btn span').html(`(${data.total_results})`);
        if (data.facets){
            let max = 0;
            let price_facets = data.facets.find(function (facet) {
                return facet[0] === "Price";
            });
            if(price_facets){
                price_facets[1].forEach(function (price_id) {
                    max = Math.max(max,GIFT_FINDER_OBJECT.priceIdToNormalPrice(price_id[0])[1]);
                });
                GIFT_FINDER_OBJECT.vars.max_available_price = max;
            } else {
                GIFT_FINDER_OBJECT.vars.max_available_price = 200;
            }
        }
    }
};

/**
 * Get the narrow setup from the ISP_LAST_SEARCH["narrow_by"] object
 *
 * @returns {Object} or empty Object
 */
const getGiftFinderSetup = () => {
    if(typeof  ISP_LAST_SEARCH === "undefined") return {};

    // // const tags = ISP_LAST_SEARCH["narrow_by"].find(term => term[0] === "Tag");
    const ageNarrow = ISP_LAST_SEARCH["narrow_by"].find(term => term[0] === GIFT_FINDER_OBJECT.consts.age_tag_name);
    const categoryNarrow = ISP_LAST_SEARCH["narrow_by"].find(term => term[0] === GIFT_FINDER_OBJECT.consts.category_tag_name);
    const popularCategoryNarrow = ISP_LAST_SEARCH["narrow_by"].find(term => term[0] === GIFT_FINDER_OBJECT.consts.popular_with_tag_name);
    const priceNarrow = ISP_LAST_SEARCH["narrow_by"].find(term => term[0] === GIFT_FINDER_OBJECT.consts.price_filter_name);
    return {
        age: ageNarrow ? ageNarrow[1][0] : null,
        category: categoryNarrow ? categoryNarrow[1][0] : null,
        popular_with: popularCategoryNarrow ? popularCategoryNarrow[1][0] : null,
        price: priceNarrow ? parsePriceToArray(priceNarrow[1][0]) : null
    };
};

/**
 * parse the price string to an array "xxx-yyy" => [xxx,yyy]
 *
 * @param price
 * @returns Array
 */
const parsePriceToArray = (price) => {
    return price.split("-").map(number => {
        const price = parseFloat(number);
        if(price === 150) return 110;
        if(price >= 200) return 120;
        return price;
    })
};